/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/App/Account/Content/Content/Home/AppointmentBookings/Content/BookingDetails/DateTimeMissed/Content/Time"
  
}) {
let appointmentAppointmentBookings0LocalStartTimeValueData = fromData.useDataFormat({ viewPath,
context: 'appointment',
path: 'appointment_bookings[0].local_start_time',
format: fromFormat.localStartTime,
})
  return (<React.Fragment
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 data="appointment.appointment_bookings[0].local_start_time"
 format="/Data/format.js localStartTime"
 text={appointmentAppointmentBookings0LocalStartTimeValueData}
/>
{children}
</React.Fragment>)
}